import { render, staticRenderFns } from "./ModalWithTabs.vue?vue&type=template&id=30b7807f&scoped=true&"
import script from "./ModalWithTabs.vue?vue&type=script&lang=js&"
export * from "./ModalWithTabs.vue?vue&type=script&lang=js&"
import style0 from "./ModalWithTabs.vue?vue&type=style&index=0&id=30b7807f&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30b7807f",
  null
  
)

export default component.exports